import React from 'react';
import styles from './styles.module.styl';

const SearchField = props => (
  <div className={styles.searchContainer}>
    <form id="search" role="search" autoComplete="off">
      <div className="form-group search-control">
        <i className="icon-budicon-489 search-icon" />
        <input type="text" id="search-input" className="search-input form-control" {...props} />
      </div>
    </form>
  </div>
);

export default SearchField;
